<template>
  <div :class="rootClass" v-if="!isApp" ref="navigation" :style="{ 'padding-top': statusBarHeight + 'px' }">
    <div class="top" ref="top" v-show="debug"></div>
    <div class="left" v-if="!adaption" @click="goBack">
      <slot name="left">
        <div class="back" v-show="showBack">
          <div class="arrow-back">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 30">
              <path fill-rule="evenodd" d="M6.600,15.000 L7.600,14.000 L17.400,4.200 C18.174,3.426 18.174,2.174 17.400,1.399 L17.400,1.399 C16.626,0.626 15.373,0.626 14.599,1.399 L0.001,15.999 L0.001,15.999 L14.599,30.599 C15.373,31.374 16.626,31.374 17.400,30.599 L17.400,30.599 C18.174,29.825 18.174,28.574 17.400,27.799 L7.600,18.000 L6.600,17.000 "></path>
            </svg>
          </div>
        </div>
      </slot>
    </div>

    <div class="center" @click="$emit('center-click')" v-if="!adaption">
      <slot></slot>
    </div>

    <div class="right" @click="$emit('right-click')" v-if="!adaption">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
import router from '../../../router'
import { naBridge, jsBridge } from '@/assets/jsBridge'
import { getKey } from '../../../assets/utils'

export default {
  name: 'navigation',

  description: '导航',

  data () {
    return {
      isApp: false,
      statusBarHeight: 0
    }
  },

  props: {
    showBack: {
      type: Boolean,
      default: true
    },

    onBack: {
      type: Function,
      default: () => {
        const currentPage = location.pathname
        router.go(-1)
        let currentTime = new Date().getTime()
        let frame
        const hack = () => {
          if (new Date().getTime() - currentTime > 200) {
            if (location.pathname === currentPage) {
              jsBridge('exit')
            }
            window.cancelAnimationFrame(frame) 
          } else {
            window.requestAnimationFrame(hack)
          }
        }
                    
        frame = window.requestAnimationFrame(hack)
      }
    },

    // 是否自定义点击事件
    customClickEvent: {
      type: Boolean,
      default: false
    },

    sticky: {
      type: Boolean,
      default: true
    },

    fixed: {
      type: Boolean,
      default: false
    },

    align: {
      type: String,
      default: 'top' // 可选值top，bottom
    },

    debug: { // 在领分期App内跑需要兼容他们状态栏，打开debug可以看到状态栏高度
      type: Boolean,
      default: false
    },

    adaption: { // 不显示只是为了兼容APP
      type: Boolean,
      default: false
    }
  },

  computed: {
    rootClass () {
      let cls = ['nd-navigation']
      return cls
    }
  },

  methods: {
    goBack () {
      this.$emit('click')
      if (!this.customClickEvent) {
        this.onBack()
      }
    },

    inApp () {
      let ua = navigator.userAgent
      return /ndmicroapp/.test(ua)
    }
  },

  mounted () {
    const jsBridge = getKey('jsBridge')
    if (jsBridge) {
      const bridge = jsBridge.hasJsBridge
      const statusBarHeight = jsBridge.statusBarHeight

      if (bridge) {
        this.statusBarHeight = statusBarHeight
      }
    }
  },

  created () {
    naBridge('goBack', () => {
      return false
    })
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

   .nd-navigation {
        padding: 0 30px;
        height: 110px;
        justify-content: space-between;
        align-items: center;
        position: relative;
        display: flex;
        background-color: #FFFFFF;
        z-index: 1000;
        font-size: 36px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: @fc1;
        box-sizing: content-box;

        .top {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            background-color: red;
        }

        .left {
            .arrow-back {
                height: 39px;
                width: 22px;
                fill: @fc1;
            }
        }

        .right {
            color: #2d8cf0;
        }

        &.transparent {
            background-color: transparent!important;
            border-bottom: none;
        }

        &.white {
            color: #FFFFFF;

            .left {
                .arrow-back {
                    fill: #FFFFFF;
                }
            }

            .center {
                color: #FFFFFF;
            }
        }

        &.fixed-top {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
        }

        &.fixed-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }

        &.sticky {
            position: sticky;
            top: 0;
        }

        &.only-adaption {
            height: 0;
            z-index: 0;
        }
    }
</style>